import styled, { css } from 'styled-components';
import { getSpacingToken, getTextTokenPreset, getToken } from '@optimus-web/common';
import { BorderStyle, DividerDirection, DividerSize } from './Divider';

export const DividerContainer = styled.div<{ direction: DividerDirection }>`
    display: flex;
    align-items: center;
    height: ${({ direction }) => (direction === 'horizontal' ? 'auto' : '100%')};
    flex-direction: ${({ direction }) => (direction === 'horizontal' ? 'row' : 'column')};
`;

export const DividerElement = styled.div<{
    direction: DividerDirection;
    size: DividerSize;
    borderStyle?: BorderStyle;
}>`
    flex: 1 1;
    ${({ size, direction, borderStyle }) =>
        direction === 'horizontal'
            ? css`
                  border-top: ${size === 'large' ? getToken('borderWidth800') : getToken('borderWidth100')}px
                      ${borderStyle};
              `
            : css`
                  border-left: ${size === 'large' ? getToken('borderWidth800') : getToken('borderWidth100')}px
                      ${borderStyle};
              `}
    border-color: ${getToken('borderStaticSecondary')};
`;

export const DividerContent = styled.div`
    color: ${getToken('textStaticSecondary')};
    ${getTextTokenPreset('bodySmallStrong')};
    padding: 0 ${getSpacingToken('150')}px;
`;
